import { useCallback, useEffect, useRef, useState } from "react";

const HIGHLIGHT_MS = 4000;

/**
 * Marks rows as just-changed so the table can tint them briefly.
 *
 * A bulk action can touch rows scattered down a long list, and the count in the
 * toolbar does not tell you which. The tint fades on its own so it never becomes
 * state the user has to clear.
 */
const useRecentlyChangedRows = (holdMs = HIGHLIGHT_MS) => {
	const [changedIds, setChangedIds] = useState(() => new Set());
	const timerRef = useRef(null);

	const clearTimer = () => {
		if (timerRef.current) clearTimeout(timerRef.current);
		timerRef.current = null;
	};

	const markChanged = useCallback(
		(taskIds) => {
			if (!taskIds?.length) return;
			clearTimer();
			setChangedIds(new Set(taskIds));
			timerRef.current = setTimeout(() => setChangedIds(new Set()), holdMs);
		},
		[holdMs]
	);

	useEffect(() => clearTimer, []);

	return { changedIds, markChanged };
};

export default useRecentlyChangedRows;
